// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"624":"2c3c52de","670":"91e62f90","862":"e5836f0f"}[chunkId] + ".chunk.js";
};